import generateBoundary from "./utils";
import AbstractService from "./AbstractService";

class UserProfileService extends AbstractService {

  static _getUrl(partUrl) {
    return `/rest/v1${partUrl}`;
  }

  static _getUrlWithParent(partUrl) {
    return `${super._getUrl()}${partUrl}`;
  }

  static async getNavPermissions() {
    const url = this._getUrl(`/get-nav-permissions`);
    return await this._getResource(url);
  }

  static async getSubDealerGroups() {
    const url = this._getUrlWithParent(`/get-subdealer-groups`);

    const resp = await this._getResource(url);

    return {
      data: resp,
    };
  }


  static async getProfile() {
    const url = this._getUrl(`/get-profile`);
    return await this._getResource(url);
  }

  static async saveProfile(data) {
    const url = this._getUrl(`/save-profile`);
    return await this._setResource(url,
      {
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
        method: 'patch',
        data,
      });
  }

  static async deleteOwnAvatar() {
    const url = this._getUrl(`/delete-own-avatar`);
    return await this._setResource(url,
      {
        method: 'patch',
      });
  }

  static async deleteOwnManagerNicknameAvatar() {
    const url = this._getUrl(`/delete-own-manager-nickname-avatar`);
    return await this._setResource(url,
      {
        method: 'patch',
      });
  }

  static async changePassword(data) {
    const url = this._getUrl(`/change-password`);
    const resp = await this._setResource(url,
      {
        data,
      });

    return {
      data: resp.results
    }
  }

}

export default UserProfileService;


